import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { FollowState, MeState } from './me.state';
import { PaginableUsersHttpResult } from 'app/modules/dashboard/models/users.model';
import { Pagination } from 'app/modules/dashboard/models/pagination.model';
import { User } from 'app/models';
import { Equipment } from 'app/modules/dashboard/models/equipment.model';
import { Settings } from 'app/modules/dashboard/models/settings.model';
import { Unit } from '@kinomap-dev/ng-ui-lib';

type MeSelectorType<T> = MemoizedSelector<object, T, (s1: MeState) => T>;

export const selectMeState = createFeatureSelector<MeState>('me');

export const selectProfileData: MeSelectorType<User> = createSelector(
  selectMeState,
  (me: MeState) => me.profile.informations
);

export const selectSettings: MeSelectorType<Settings> = createSelector(
  selectMeState,
  (me: MeState) => me.settings
);

export const selectMeCurrency: MeSelectorType<Settings['currency']> =
  createSelector(selectMeState, (me: MeState) =>
    me.settings === null ? 'eur' : me.settings.currency
  );

export const selectProfileLoading: MeSelectorType<boolean> = createSelector(
  selectMeState,
  (me: MeState) => me.profile.loading
);

export const selectFollows: MeSelectorType<FollowState> = createSelector(
  selectMeState,
  (me: MeState) => me.follows
);

export const selectFollowers: MeSelectorType<PaginableUsersHttpResult> =
  createSelector(selectMeState, (me: MeState) => me.follows.followers.users);

export const selectFollowings: MeSelectorType<PaginableUsersHttpResult> =
  createSelector(selectMeState, (me: MeState) => me.follows.followings.users);

export const selectFollowersLoading: MeSelectorType<boolean> = createSelector(
  selectMeState,
  (me: MeState) => me.follows.followers.loading
);

export const selectFollowersLoaded: MeSelectorType<boolean> = createSelector(
  selectMeState,
  (me: MeState) => me.follows.followers.loaded
);

export const selectFollowersPagination: MeSelectorType<Pagination> =
  createSelector(
    selectMeState,
    (me: MeState) => me.follows.followers.users.meta
  );

export const selectFollowingsLoading: MeSelectorType<boolean> = createSelector(
  selectMeState,
  (me: MeState) => me.follows.followings.loading
);

export const selectFollowingsLoaded: MeSelectorType<boolean> = createSelector(
  selectMeState,
  (me: MeState) => me.follows.followings.loaded
);

export const selectFollowingsPagination: MeSelectorType<Pagination> =
  createSelector(
    selectMeState,
    (me: MeState) => me.follows.followings.users.meta
  );

export const selectEquipments: MeSelectorType<Equipment[]> = createSelector(
  selectMeState,
  (me: MeState) => me.equipments.equipments
);

export const selectMeUnit: MeSelectorType<Unit> = createSelector(
  selectMeState,
  (me: MeState) => me.settings?.unit || 'metric'
);
